'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIPromptable;

var _underscore = require('../utils/underscore');

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactUtils = require('react-utils');

var _RootNode = require('../utils/RootNode');

var _PromptablePropInterface = require('./PromptablePropInterface');

var _PromptablePropInterface2 = _interopRequireDefault(_PromptablePropInterface);

var _UIFullScreen = require('../dialog/UIFullScreen');

var _UIFullScreen2 = _interopRequireDefault(_UIFullScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param  {React.Component}
 * @return {React.Component}
 */
function enforceIsPromptable(Component) {
  var displayName = Component.displayName,
      propTypes = Component.propTypes;

  Object.keys(_PromptablePropInterface2.default).forEach(function (propName) {
    (0, _reactUtils.invariant)(propTypes && propTypes[propName] === _PromptablePropInterface2.default[propName], "UIPromptable: %s doesn't implement %s from PromptablePropInterface", displayName, propName);
  });
  return Component;
}

/**
 * @param  {React.Component}
 * @param  {HTMLElement}
 * @param  {?Object}
 * @param  {?React.Component} parentComponent - ReactComponent instance
 * @return {Promise}
 */
function doPrompt(Component, contextRootNode, additionalProps, parentComponent) {
  var element = document.createElement('div');

  return _q2.default.promise(function (resolve, reject) {
    var WrappedComponent = _react2.default.createElement(
      _UIFullScreen2.default,
      { rootNode: contextRootNode },
      _react2.default.createElement(Component, _extends({}, additionalProps, { onConfirm: resolve, onReject: reject }))
    );

    if (parentComponent) {
      _reactDom2.default.unstable_renderSubtreeIntoContainer(parentComponent, WrappedComponent, element);
    } else {
      _reactDom2.default.render(WrappedComponent, element);
    }
  }).finally(function () {
    _reactDom2.default.unmountComponentAtNode(element);
  });
}

/**
 * @param  {React.Component}
 * @param  {HTMLElement}
 * @return {(additionalProps: ?Object) => Promise}
 */
function UIPromptable(Component) {
  var contextRootNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _RootNode.getDefaultNode)();

  return (0, _underscore.partial)(doPrompt, enforceIsPromptable(Component), contextRootNode);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/decorators/Promptable.js
// module id = 320
// module chunks = 0